import { CompanyTypeDTO, SettingDTO } from 'src/services/generated/api.generated.v1';
import MapService from 'src/services/MapService';
import { MutationTree } from 'vuex';
import { SettingStateInterface } from './state';

const mutation: MutationTree<SettingStateInterface> = {
  updateSettingState(state: SettingStateInterface, settings: SettingDTO | null) {
    state.googleMapsApiKey = settings?.googleMapsApiKey ?? null;
    state.allowedFileUploadExtensions = settings?.allowedFileUploadExtensions ?? null;
    state.maxFileUploadSizeInMegaBytes = settings?.maxFileUploadSizeInMegaBytes ?? null;
    state.maxAdditionalConsumerUsers = settings?.maxAdditionalConsumerUsers ?? null;
    state.fullAccessCountryCodes = settings?.fullAccessCountryCodes ?? null;
    state.initialized = settings !== null;
    state.mondayThruThursdaySupportHours = settings?.mondayThruThursdaySupportHours ?? null;
    state.fridaySupportHours = settings?.fridaySupportHours ?? null;

    if (state.googleMapsApiKey) {
      MapService.SetMapsLoader(state.googleMapsApiKey);
    }
  },
  updateSettingConsumerSupportState(state: SettingStateInterface, company: CompanyTypeDTO | null) {
    state.consumerSupportEmail = company?.supportEmailAddress ?? null;
    state.consumerSupportPhone = company?.supportPhoneNumber ?? null;
    state.consumerPartsEmail = company?.partsEmailAddress ?? null;
    state.consumerServiceEmail = company?.serviceEmailAddress ?? null;
    state.companyAddress = company?.companyAddress ?? null;
  },
  setCompany(state: SettingStateInterface, company: string) {
    state.company = company;
  },
  setCompanyDisplayName(state: SettingStateInterface, displayName: string) {
    state.companyDisplayName = displayName;
  },
  setPlatform(state: SettingStateInterface, platform: string) {
    state.platform = platform;
  },
}


export default mutation;